import React from "react";
import Summary from "./Summary";

const Footer = (props) => {
  if (!props.showPaging) {
    return null;
  }

  return <Summary {...props} />;
};

export default Footer;
